// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  auth0_domain: "dev-lx14cqer.us.auth0.com",
  auth0_clientId: "Ul90bFivbvkKBUbf5GubdKpASNQHj7Jt",
  auth0_audience: "https://dev-lx14cqer.us.auth0.com/api/v2/",
  useRefreshTokens: true,
  reportsUrl: 'https://reports.dev.baup.com.ar'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
